const images = document.querySelectorAll('.img-parallax img');
const breakpoint = window.matchMedia('(max-width: 1023px)');

const getInnerHeight = (elm) => {
  const computed = getComputedStyle(elm);
  const padding = parseInt(computed.paddingTop, 10) + parseInt(computed.paddingBottom, 10);

  return elm.clientHeight - padding;
};

const parallaxImg = (img) => {
  const imgParent = img.closest('.img-parallax');
  const speed = 1;
  const imgY = imgParent.offsetTop;
  const winY = window.scrollY;
  const winH = window.innerHeight;
  const parentH = getInnerHeight(imgParent);
  let imgPercent;

  const winBottom = winY + winH;

  const imgBottom = ((winBottom - imgY) * speed);
  const imgTop = winH + parentH;
  imgPercent = ((imgBottom / imgTop) * 100) + (50 - (speed * 50));
  // if (imgPercent <= 10) {
  //   imgPercent = 0;
  // }
  img.style.top = (imgPercent - 3) + '%';
  img.style.transform = 'translate(-50%, -' + (imgPercent - 3) + '%)';
};

const initImageParallax = () => {
  if (breakpoint.matches) {
    return;
  } else if (images.length) {
    images.forEach((img) => {
      parallaxImg(img);
    });

    window.addEventListener('scroll', () => {
      images.forEach((img) => {
        parallaxImg(img);
      });
    }, true);
  }
};

export {initImageParallax};
